import {
  RavenCheckBox,
  RavenInputField,
  RavenModal,
 
} from "@ravenpay/raven-bank-ui";
import Icons from "../../../../assets/icons/icons";
import "../../../../styles/dashboard/insights/manageStreamKeysIndex.css";
import {  useEffect, useState } from "react";

import RootState from "../../../../redux/types";
import { createStreamKey, getSingleInsightTerminals, getStreamKey } from "../../../../redux/insight";
import { useDispatch, useSelector } from "react-redux";
import { generateRandomNumber } from "../../../../utils/generateRandomNumber";

import { getDateTimeObject, removeSpace } from "../../../../utils/helpers";

import BadgeComponent from "../../../../fragments/badge/BadgeComponent";

interface ModalProps {
  visible?: boolean;
  onClose?: () => void;
  onClick?: () => void;
  serial?: string;
}
const ManageStreamModal = ({ visible, onClose, onClick,serial, }: ModalProps) => {
  const [showManage, setShowManage] = useState(false);
  const [showPin, setShowPin] = useState(false);
  const [showDate, setShowDate] = useState(true);
  const [showKey, setShowKey] = useState(false);
  const [copied, setCopied] = useState(false);
  const { loading_alert, insight_terminal, stream_key_info, loading_reciept } =
    useSelector((state: RootState) => state.insights);

  const [copiedKey, setCopiedKey] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [completePin, setCompletePin] = useState(false);
  const dispatch = useDispatch();
  interface UserDetails {
    account_number?: string;
    clear_keys?: string;
    use_key?: string;
    expire_at?: string;
    history_enabled?: boolean;
    enable_date?: boolean;
  }

  const [details, setDetails] = useState<UserDetails>({
    account_number: "",
    use_key: "",
    expire_at: "",
    history_enabled: false,
    enable_date: false,
  });
  const getTerminalDetails = async () => {
    const obj = {
      serial,
    };
    dispatch(getSingleInsightTerminals(obj as any) as any);
  };
  const handleGenerateKey = async () => {
    const obj = {
      ...details,
      account_number:
        insight_terminal?.terminalData?.account_info?.account_number,
    };

    // console.log(obj);
    // console.log(stream_key_info);

    const data = await dispatch(createStreamKey(obj as any) as any);

    if (data?.payload?.status === "success") {
      getTerminalDetails();
      handleFinish();
      onClose?.();

      
    } else {
      // console.error("Request failed:", data);
    }
  };

  const handleChange = (e: any) => {
    const { name, value } = e?.target;
    const newObj = { ...details, [name]: value };
    setDetails(newObj);
  };

  function generateAccountNumber() {
    const key = generateRandomNumber();
    setDetails((prev) => {
      return {
        ...prev,
        use_key: key,
      };
    });
  }

  const handleFinish = () => {
    const clearedDetails = {
      account_number: "",
      clear_keys: "",
      use_key: "",
      expire_at: "",
      history_enabled: false,
    };

    setDetails(clearedDetails);
    setShowPin(false);
    const obj = {
      ...details,
      account_number:
        insight_terminal?.terminalData?.account_info?.account_number,
    };

    dispatch(getStreamKey(obj as any) as any);
    // console.log(clearedDetails);

    setShowManage(false);
    visible=true
  };

  const handleClose = () => {
    onClose && onClose();
    setDetails((prev) => {
      return { ...prev, account_number: "", use_key: "" };
    });
    setCompletePin(false);
    setEditMode(false);
  };

  useEffect(() => {
    if (Object?.keys(stream_key_info)?.length > 0 && visible) {
      console.log("this is stream key info", stream_key_info);
      setDetails((prev) => {
        return {
          ...prev,
          use_key: stream_key_info?.stream_key || "",
          expire_at: stream_key_info?.expires_at
            ? getDateTimeObject(stream_key_info?.expires_at)?.date
            : "",
          account_number:
            insight_terminal?.terminalData?.account_info?.account_number,
        };
      });
      stream_key_info?.expires_at && setShowDate(true);
    }
  }, [
    stream_key_info,
    visible,
    insight_terminal
  ]);

  const handleDisable = () => {
    // let val;
    if (details?.enable_date) {
      const data =
        !details?.use_key ||
        removeSpace(String(details?.use_key))?.length < 6 ||
        !details?.expire_at;
      return data;
    } else {
      const data =
        !details?.use_key || removeSpace(String(details?.use_key))?.length < 6;
      return data;
    }
    // return val;
  };

  return (
    <RavenModal
      btnColor="deep-green-light"
      btnLabel={loading_reciept ? "" : editMode ? "Manage Stream Key" : "Close"}
      visble={visible}
      loading={loading_alert}
      onClose={() => {
        handleClose();
      }}
      disabled={editMode && handleDisable()}
      onBtnClick={
        onClick ??
        (() => {
          if (editMode) {
            handleGenerateKey();
           
          }
          if(!editMode){
            onClose && onClose()
          }
          
        })
      }
      className="create-stream-modal"
    >
      <div className="manage_stream_key_general_wrap">
        <div className="title-text-box border-theme-bottom">
          <p className="title">Manage Stream Key</p>
          <p className="text grey-white-color">
            Use the stream key to manage your transactions and your inflows.
          </p>
        </div>
        <div className="manage_modal_middle_box_wrapper">
          {!editMode ? (
            <div className="manage_stream_key_grey_area_wrap">
              <div
                className="manage_stream_key_grey_area_section_wrap"
                style={{
                  paddingBottom: "2rem",
                  borderBottom: "0.10rem solid #E5E6E6",
                }}
              >
                <div className="manage_stream_key_grey_area_section_wrap_header_text">
                  <p className="manage_stream_key_grey_area_header_text">
                    Stream Key
                  </p>
                  <p className="manage_stream_key_grey_area_body_text">
                    {" "}
                    {details?.use_key || "---"}
                  </p>
                </div>
                <div className="manage_stream_key_grey_area_section_wrap_figure_box">
                  <div
                    className="manage_stream_key_icon_item"
                    onClick={() => setEditMode(true)}
                  >
                    <figure>{Icons.editpenIcon}</figure>
                  </div>
                  <div
                    className="manage_stream_key_icon_item"
                    onClick={() => {
                      const valueToCopy = details?.use_key || "---";
                      navigator.clipboard.writeText(valueToCopy);
                      setCopiedKey(true);
                      setTimeout(() => setCopiedKey(false), 1500);
                    }}
                  >
                    <figure>{Icons.copyIcon}</figure>
                    {copiedKey && (
                      <span className="copied-feedbackkey">Copied!</span>
                    )}
                  </div>
                </div>
              </div>
              <div className="manage_stream_key_grey_area_section_wrap">
                <div className="manage_stream_key_grey_area_section_wrap_header_text">
                  <p className="manage_stream_key_grey_area_header_text">
                    Account No
                  </p>

                  <p className="manage_stream_key_grey_area_body_text">
                    {" "}
                    {insight_terminal?.terminalData?.account_info
                      ?.account_number || "---"}
                  </p>
                </div>
                <div className="manage_stream_key_grey_area_section_wrap_figure_box">
                  <div
                    className="manage_stream_key_icon_item"
                    onClick={() => {
                      const accountNumber =
                        insight_terminal?.terminalData?.account_info
                          ?.account_number;
                      if (accountNumber) {
                        navigator.clipboard.writeText(accountNumber);
                        setCopied(true);
                        setTimeout(() => setCopied(false), 2000); // reset after 2s
                      }
                    }}
                  >
                    <figure>{Icons.copyIcon}</figure>
                    {copied && <span className="copied-feedback">Copied!</span>}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="form-box">
              {/* input field start */}
              <div className="stream-number-input-box">
                <RavenInputField
                  type="account-number"
                  color="black-light"
                  className="input"
                  placeholder="000000"
                  value={details?.use_key}
                  name={`use_key`}
                  onChange={handleChange}
                  maxLength={6}
                />
              </div>
              {/* input field end */}

              {/* down label box start */}
              <div className="down-label-generate-box">
                <p className="label-down grey-white-color">
                  Enter a 6 digit code or{" "}
                </p>{" "}
                <BadgeComponent
                  onClick={generateAccountNumber}
                  className={`pending badge`}
                  text={`Auto Generate Key`}
                />
              </div>
              {/* down label box end */}
            </div>
          )}
        </div>

        <div className="manage_stream_key_general_wrap_bottom_wrap">
          {/* <div className="manage_stream_key_enable_history_box">
              <RavenCheckBox
                id={160000}
                key={160000}
                color="deep-green-light"
                onChange={() => {
                  // setEnablehistory((prev) => !prev);
                  setDetails((prev) => {
                    return {
                      ...prev,
                      history_enabled: !details?.history_enabled,
                    };
                  });
                }}
                checked={details?.history_enabled}
              />
              <p
                className={`
                       enable_transaction_history ${
                         enableHistory ? "bold_text" : ""
                       }`}
              >
           Transaction History Enabled
              </p>
            </div>

            <div className="create_stream_key_date_box">
              <RavenCheckBox
                id={15000}
                key={15000}
                color="deep-green-light"
                onChange={(e) => {
                  setShowDate(!showDate);
                  !showDate &&
                    setDetails((prev) => {
                      return { ...prev, expire_at: "" };
                    });
                }}
                checked={showDate}
              />

              <p className={`expiry_text_box ${showDate ? "active" : ""}`}>
              Expires on {details?.expire_at || "---"}
              </p>
            </div> */}

          {/* list box start */}
          <div className="list-box-to-set">
            {editMode ? (
              <div className="label-check-box">
                <RavenCheckBox
                  color="deep-green-light"
                  onChange={() => {
                    setDetails((prev) => ({
                      ...prev,
                      history_enabled: !prev.history_enabled,
                    }));
                  }}
                  checked={details.history_enabled}
                  id={7747478999}
                />
                <p className="label grey-white-color-white">
                  Enable Transaction History
                </p>
              </div>
            ) : (
              details.history_enabled && (
                <div className="label-check-box">
                  <RavenCheckBox
                    color="deep-green-light"
                    checked={true}
                    onChange={() => {
                      console.log();
                    }}
                    id={7747478998}
                  />
                  <p className="label grey-white-color-white">
                    Transaction History Enabled
                  </p>
                </div>
              )
            )}

            {editMode ? (
              <div className="label-check-box">
                <RavenCheckBox
                  color="deep-green-light"
                  checked={details.enable_date}
                  onChange={() => {
                    setDetails((prev) => ({
                      ...prev,
                      enable_date: !prev.enable_date,
                    }));
                    console.log(details.enable_date);
                  }}
                  id={77474759}
                />
                <p className="label grey-white-color-white">Set Expiry Date</p>
              </div>
            ) : (
              details.expire_at && (
                <div className="label-check-box">
                  <RavenCheckBox
                    color="deep-green-light"
                    checked={true}
                    onChange={() => {
                      console.log();
                    }}
                    id={774747892}
                  />
                  <p className="label grey-white-color-white">
                    Expires on {details.expire_at}
                  </p>
                </div>
              )
            )}
          </div>
          {/* list box end */}
          {/* date input field start */}
          <div
            className={`date-input-wrap-box-stream ${
              details?.enable_date ? "date-input-wrap-box-stream-show" : ""
            }`}
          >
            <RavenInputField
              dateOptions={{ minDate: new Date() }}
              // enableTime
              placeholder="Select expiry date"
              value={details?.expire_at}
              onChange={(date: any) => {
                setDetails((prev) => {
                  return {
                    ...prev,
                    expire_at: getDateTimeObject(date[0])?.date,
                  };
                });
              }}
              type="date"
              color="deep-green-light"
            />
          </div>
          {/* date input field end */}
        </div>
      </div>
    </RavenModal>
  );
};
export default ManageStreamModal;
